module.exports = __webpack_public_path__ + "images/garmin_connect.svg";